// UX-side mirror of worker business rules.
// These are for rendering only — the worker is the source of truth for validation.

const KCAppointmentConfig = {
  AVAILABLE_DAYS: [2, 4], // Tuesday=2, Thursday=4
  START_HOUR: 10,
  END_HOUR: 14,
  SLOT_DURATION: 30, // minutes
  TIMEZONE: 'Europe/Berlin',
  TEMP_BLOCK_TTL: 900, // 15 minutes in seconds
  BOOKING_WINDOW_WEEKS: 4,
  API_BASE: 'https://kc-appointments.cdtcom.workers.dev',
  DAY_NAMES: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  MONTH_NAMES: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
};

if (typeof window !== 'undefined') {
  window.KCAppointmentConfig = KCAppointmentConfig;
}
